// extracted by mini-css-extract-plugin
module.exports = {"WheelSvg":"Spinner_WheelSvg__1jMaA","spin":"Spinner_spin__1L1Ft","PrimaryColor":"Spinner_PrimaryColor__EbwMQ","SecondaryColor":"Spinner_SecondaryColor__3wSDz"};